function processSlots(product, selectedRentalStartAt, filteredSlots) {
  const slots = Object.values(product?.settings?.slots || {});
  const slotsEnd = Object.values(product?.settings?.slotsEnd || {});

  if (!product?.entity_rent_minutes_fraction_break || product?.entity_rent_minutes_fraction_break === 0) {
    if (selectedRentalStartAt) {
      return slots
        .map((time, index) => {
          if (index < slots.length - 1) {
            const unavailables = filteredSlots
              ? filteredSlots
                  .map((v) => {
                    //@ts-ignore
                    return Object.values(v).map((slt) => slt?.split(" ")[1]);
                  })
                  .flat()
              : null;

            const actualUnavailable = unavailables ? unavailables[0] === time && unavailables[1] === slots[index + 1] : false;

            return {
              hour_start_at: time,
              hour_end_at: slots[index + 1],
              isUnavailable: actualUnavailable,
            };
          }
          return null;
        })
        .filter(Boolean);
    }
    return [];
  } else {
    return slots.map((time, index) => {
      return {
        hour_start_at: time,
        hour_end_at: slotsEnd[index],
      };
    });
  }
}

export function renderAvailabilityMessage(trans) {
  // Create the container div
  const container = document.createElement("div");
  container.id = "loading-hourly-slots";
  container.style.display = "flex";
  container.style.margin = "auto";
  container.style.justifyContent = "center";
  container.style.alignItems = "center";
  container.style.height = "275px";

  // Create the icon element
  const icon = document.createElement("i");
  icon.className = "fa fa-calendar"; // Assuming the icon is from a library like Line Awesome
  icon.style.marginRight = "8px"; // Optional spacing

  // Create the span element
  const span = document.createElement("span");
  span.textContent = trans("website.checking-availability-please-wait"); // Replace with trans() if needed

  // Append the icon and span to the container
  container.appendChild(icon);
  container.appendChild(span);

  //Return element
  return container;
}

export function renderHourly(trans, product, selectedRentalStartAt, setSelectedShift, selectedShift, filteredSlots) {
  // Process slots using the logic from processSlots
  const processedSlots = processSlots(product, selectedRentalStartAt, filteredSlots);
  console.log("Processed slots: ", processedSlots);

  // Create form group container
  const formGroup = document.createElement("div");
  formGroup.id = "renderHourly";
  formGroup.className = "form-group";
  formGroup.style.marginTop = "20px";
  formGroup.style.marginBottom = "20px";

  // Add bold text header
  const header = document.createElement("div");
  header.className = "text-bold-600 font-medium-2 fw-bold ms-2 mb-2";
  header.textContent = `${trans("website.entity-hour-fraction-start")}/${trans("website.entity-hour-fraction-end")}`;
  formGroup.appendChild(header);

  // Create row container
  const row = document.createElement("div");
  row.className = "row ms-1 me-1";
  row.style.flexWrap = "wrap";

  // Iterate over processed slots and render each
  processedSlots.forEach((slot: any) => {
    const { hour_start_at, hour_end_at, isUnavailable } = slot;

    const col = document.createElement("div");
    col.setAttribute("hourly-start-end", `${hour_start_at}-${hour_end_at}`);
    col.className = `col-4 col-md-3 rounded-2 p-2 text-center shadow-sm ${isUnavailable ? "text-gray bg-gray" : "text-black"}`;
    col.style.cursor = isUnavailable ? "default" : "pointer";

    // Handle click event
    col.onclick = () => {
      if (isUnavailable) return;
      document.querySelectorAll(`[hourly-start-end]`).forEach((el) => (el["style"].border = "1px solid #cccccc25"));
      col.style.border = "1px solid #9bc63f";
      setSelectedShift({ hour_start_at, hour_end_at });
    };

    // Add time label
    const timeLabel = document.createElement("div");
    timeLabel.className = "m-1";
    timeLabel.textContent = `${hour_start_at} até ${hour_end_at}`;
    col.appendChild(timeLabel);

    // Append the column to the row
    row.appendChild(col);
  });

  // Append the row to the form group
  formGroup.appendChild(row);

  let selectDateFeedback = document.createElement("span");
  selectDateFeedback.id = "selectDateFeedback";
  selectDateFeedback.style.color = "red";
  selectDateFeedback.style.display = "none";
  selectDateFeedback.textContent = `${trans("website.select-a-date-first")}`;

  formGroup.appendChild(selectDateFeedback);

  if (row.children.length === 0) {
    selectDateFeedback.style.display = "block";
  }

  return formGroup;
}
